<template>
  <Button v-bind="allProps">
    <template v-for="(slot, name) in $slots" #[name]="slotProps" v-bind:key="name">
      <component :is="slot" v-bind="slotProps" />
    </template>
  </Button>
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import Button from 'primevue/button'
import type { ButtonSlots } from 'primevue/button'
import { ButtonProps } from './types'

defineSlots<Partial<ButtonSlots>>()
const props = withDefaults(defineProps<ButtonProps>(), {
  raised: true
})
const attrs = useAttrs()
const allProps = computed(() => ({
  ...attrs,
  ...props
}))
</script>
